type SignInSentProps = {
  email: string;
};
export const SignInSent = ({ email }: SignInSentProps) => {
  return (
    <div className="p-1">
      <p>
        이메일이 {email}으로 전송되었습니다.
        <br />
        이메일을 확인하여 로그인을 완료하세요.
      </p>
    </div>
  )
}
